/* eslint-disable @next/next/no-img-element */
import Typography from '@mui/material/Typography';
import { RichTextField, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { IImageProps, studySiteInfoProps } from '../shared/Carousel/Carousel.types';
import SiteLocationRichText from '../SiteLocationRichText/SiteLocationRichText';
import { ContainerBox, MainModalContainerBox } from './MyProfileQuestionnaire.style';
import { StyledLink } from '../DTP/HeaderNavigation/CallCenter/CallCenter.style';

interface IViewSiteProps {
  cardTitle: string;
  mapsLink: string;
  siteAddressFormat: RichTextField;
  sitePhoneFormat?: RichTextField;
  sitePhoneNumber?: string;
  showSiteName: boolean;
  siteInfo?: studySiteInfoProps;
  icons?: {
    hospitalIcon: IImageProps;
    locationPinIcon: IImageProps;
    phoneIcon: IImageProps;
  };
}

const ViewSiteDetails = (props: IViewSiteProps): JSX.Element => {
  const onAddressClick = () => {
    if (props?.siteInfo?.siteLatitude && props?.siteInfo?.siteLongitude) {
      const lat = props?.siteInfo?.siteLatitude.toString();
      const lon = props?.siteInfo?.siteLongitude.toFixed(4);
      const url = `${props?.mapsLink}${lat},${lon}`;
      window?.open(url);
    }
  };

  const hasPNRichTag = props?.sitePhoneFormat?.value?.includes('[pn]');
  const hasSitePhoneNumberRichTag = props?.sitePhoneFormat?.value?.includes('[sitePhoneNumber]');
  const isPhoneNumberRichTagEmpty = props?.sitePhoneFormat?.value === '';
  const showPhoneNumber = hasPNRichTag
    ? props.sitePhoneNumber
    : hasSitePhoneNumberRichTag || isPhoneNumberRichTagEmpty
    ? props.siteInfo?.sitePhone
    : false;

  return (
    <MainModalContainerBox>
      {props?.siteInfo?.siteName && props?.showSiteName && (
        <ContainerBox>
          <img src={props?.icons?.hospitalIcon?.src} alt={props?.icons?.hospitalIcon?.alt} />
          <Typography variant="body2" sx={{ color: 'neutral7.main' }}>
            <Text field={{ value: props?.siteInfo?.siteName }} />
          </Typography>
        </ContainerBox>
      )}

      {(props?.siteInfo?.siteAddress ||
        props?.siteInfo?.siteCity ||
        props?.siteInfo?.siteState ||
        props?.siteInfo?.siteCountry ||
        props?.siteInfo?.siteZipCode) && (
        <ContainerBox onClick={onAddressClick} sx={{ cursor: 'pointer' }}>
          <img
            src={props?.icons?.locationPinIcon?.src}
            alt={props?.icons?.locationPinIcon?.alt}
            height={20}
          />
          <SiteLocationRichText
            siteAddressFormat={{ value: props?.siteAddressFormat as string }}
            siteInfo={props?.siteInfo as any}
          />
        </ContainerBox>
      )}
      {showPhoneNumber && (
        <ContainerBox>
          <StyledLink
            className={'site-info-link-btn'}
            href={`tel:${props?.siteInfo?.sitePhone}`}
            target="_blank"
            sx={{ gap: '8px' }}
          >
            <img src={props?.icons?.phoneIcon?.src} alt={props?.icons?.phoneIcon?.alt} />
            <Typography variant="body2">{showPhoneNumber}</Typography>
          </StyledLink>
        </ContainerBox>
      )}
    </MainModalContainerBox>
  );
};

export default ViewSiteDetails;
